import { Navigate, useLocation, useNavigate } from 'react-router-dom'

export default function LevelUp() {
  const navigate = useNavigate()
  const location = useLocation()
  const levelUp = location.state?.levelUp || null

  if (!levelUp) {
    return <Navigate to="/game" replace />
  }

  const progress = Math.max(0, Math.min(100, Number(levelUp.progress || 0)))
  const maxed = Boolean(levelUp.reachedCap)

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,rgba(251,191,36,0.18),rgba(4,6,13,0.98)_55%)] text-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl rounded-3xl border border-amber-400/20 bg-[#07111d] shadow-[0_0_70px_rgba(251,191,36,0.16)] overflow-hidden">
        <div className="px-6 py-6 border-b border-amber-400/20">
          <p className="text-xs uppercase tracking-[0.35em] text-amber-300/70">Subida de nivel</p>
          <h1 className="text-4xl md:text-5xl font-black text-white mt-2">
            Nivel {levelUp.newLevel}
          </h1>
          <p className="text-slate-300 mt-3">
            Has subido desde el nivel {levelUp.previousLevel} al nivel {levelUp.newLevel}.
          </p>
        </div>

        <div className="p-6 space-y-5">
          <div className="rounded-2xl border border-slate-700 bg-slate-950/70 p-5">
            <div className="flex items-center justify-between text-sm text-slate-300 mb-2">
              <span>Experiencia</span>
              <span>{levelUp.newExperience.toLocaleString()} XP</span>
            </div>
            <div className="h-3 rounded-full bg-slate-800 overflow-hidden">
              <div
                className="h-full bg-amber-400"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="flex items-center justify-between text-xs text-slate-500 mt-2">
              <span>{levelUp.previousExperience.toLocaleString()} XP antes</span>
              <span>
                {maxed
                  ? 'Nivel maximo alcanzado'
                  : `Siguiente nivel: ${Number(levelUp.nextLevelExperience || 0).toLocaleString()} XP`}
              </span>
            </div>
          </div>

          <div className="grid gap-4 md:grid-cols-3">
            <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/10 p-4">
              <p className="text-xs uppercase tracking-[0.2em] text-emerald-300/70">Niveles ganados</p>
              <p className="text-3xl font-black text-white mt-2">{levelUp.levelsGained}</p>
            </div>
            <div className="rounded-2xl border border-cyan-500/20 bg-cyan-500/10 p-4">
              <p className="text-xs uppercase tracking-[0.2em] text-cyan-300/70">Puntos ganados</p>
              <p className="text-3xl font-black text-white mt-2">{levelUp.statPointsAwarded}</p>
            </div>
            <div className="rounded-2xl border border-violet-500/20 bg-violet-500/10 p-4">
              <p className="text-xs uppercase tracking-[0.2em] text-violet-300/70">Estado</p>
              <p className="text-3xl font-black text-white mt-2">{maxed ? 'Max' : 'Nuevo'}</p>
            </div>
          </div>

          <div className="rounded-2xl border border-amber-500/20 bg-amber-500/10 px-4 py-3 text-amber-100 text-sm">
            Tu bot ha evolucionado. Puedes revisar la pantalla el tiempo que quieras y volver al mapa cuando pulses el boton.
          </div>

          <div className="flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => navigate('/game', { replace: true })}
              className="rounded-xl border border-amber-500 bg-amber-600 px-5 py-3 text-white font-semibold hover:bg-amber-500"
            >
              Volver al mapa
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
